module.exports = __webpack_public_path__ + "img/lespagina_groot_wit.9265aa4c.png";